import React, { useEffect, useContext, useState } from 'react';
import { FlowContext } from '../../core/flow-engine';
import {
  getMFTransferTrackingId,
  postMutualFundFormData
} from '../../flows/shared/services/mutualfund-transfer-form-service';
import { convertAppDataToMutualFundFormData } from '../../flows/shared/services/util';
import { createFormURL } from '../../flows/shared/utils';
import styles from './styles.css';

const NonToraConfirmation = () => {
  const { appState } = useContext(FlowContext);
  const [animateFormLink, setAnimateFormLink] = useState(true);
  const [mutualFundFormURL, setMutualFundFormURL] = useState('');

  const { store } = appState;
  const transferFormPayload = convertAppDataToMutualFundFormData(store);

  const loadMutualFundTransferFormData = async payloadWithTrackingId => {
    // call form endpoint by posting application data and retreiving blob response
    const mutualfundFormBlob = await postMutualFundFormData(
      payloadWithTrackingId
    );
    // create data url here for form.
    // must be a url, blob object will not be
    // passed/stored correctly
    return setMutualFundFormURL(createFormURL(mutualfundFormBlob));
  };

  useEffect(() => {
    /* START - sure track id polling logic */
    let intervalId;
    // stops polling the tracking id endpoint after 10s
    const timeoutId = setTimeout(() => {
      clearInterval(intervalId);
      setAnimateFormLink(false);
      const payloadWithTrackingId = {
        ...transferFormPayload,
        transferTrackingID: ''
      };
      return loadMutualFundTransferFormData(payloadWithTrackingId);
    }, 10000);
    intervalId = setInterval(async () => {
      try {
        const {
          transferTrackingID = '',
          status,
          success
        } = await getMFTransferTrackingId(store);

        // poll the api until we get transferTrackingID back or
        // if it's a 200 response with no transferTrackingID value
        if (
          (Boolean(transferTrackingID) && status !== 204) ||
          success === false
        ) {
          // clear the interval and set animation
          // flag to false
          clearInterval(intervalId);
          clearTimeout(timeoutId);
          setAnimateFormLink(false);
          const payloadWithTrackingId = {
            ...transferFormPayload,
            transferTrackingID
          };
          return loadMutualFundTransferFormData(payloadWithTrackingId);
        }
      } catch (err) {
        // clear the interval and set animation
        // flag to false if there is service failure
        clearInterval(intervalId);
        clearTimeout(timeoutId);
        setAnimateFormLink(false);
        const payloadWithTrackingId = {
          ...transferFormPayload,
          transferTrackingID: ''
        };
        return loadMutualFundTransferFormData(payloadWithTrackingId);
      }
      return setMutualFundFormURL('');
    }, 3000);
    /* END - sure track id polling logic  */

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const openPDF = () => {
    try {
      window.open(mutualFundFormURL, '_blank');
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    }
  };

  return (
    <>
      <section className="next-instructions">
        <div className="step-contents">
          <h3>Complete your transfer</h3>
          <ol>
            <li>
              <strong>Print out and sign the Mutual Fund Transfer Form.</strong>
              {animateFormLink ? (
                <div className="bouncing-transfer-form-text">
                  Making your form. Please wait...
                </div>
              ) : (
                <p>
                  Print out and sign the prefilled form
                  <br />{' '}
                  <span className="download-form">
                    <span className="download-icon" />
                    <a
                      id="open-pdf-link"
                      role="button"
                      onClick={openPDF}
                      onKeyDown={openPDF}
                      tabIndex="0">
                      Mutual Fund Transfer Form
                    </a>
                  </span>
                </p>
              )}
            </li>
            <li>
              <strong>Attach your latest statement</strong>
              <p>
                Attaching your latest IRA statement makes the process faster
              </p>
            </li>
            <li>
              <strong>Mail in your form</strong>
              <p>Send to:</p>
              <address>
                T. Rowe Price
                <br />
                P.O. Box 17150
                <br />
                Baltimore, MD 21297-1150
              </address>
            </li>
          </ol>
        </div>
      </section>
      <style jsx>{styles}</style>
    </>
  );
};

export default NonToraConfirmation;
